var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.backDisabled},on:{"click":_vm.backNavigation}},[_c('i',{staticClass:"fa fa-chevron-left icon-reset"}),_vm._v("\n    Back\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }